// C1-D1 — customer-reschedule gate for MATCHi-mirrored bookings.
//
// A MATCHi-mirrored/pushed booking (matchi_slot_id OR pushed_to_matchi_at set) must NOT be
// rescheduled by a customer during coexistence: a customer move is an IN-PLACE UPDATE (same row,
// new time/court) that leaves matchi_slot_id pointing at the OLD MATCHi slot — the sync has no
// signal to free the old slot + book the new → ghost booking on the old + double-bookable new
// (proven: incident 058fc982). Such moves stay ADMIN-only (admin path verifies MATCHi manually).
//
// SINGLE SOURCE for BOTH render surfaces — Bookings.tsx (desktop table) + BookingActions.tsx
// (mobile card). Drift between them = a platform leak (the gate must be identical on both).

import type { Tables } from "@/integrations/supabase/types";

type BookingMoveFields = Pick<
  Tables<"bookings">,
  "status" | "start_time" | "matchi_slot_id" | "pushed_to_matchi_at"
>;

/** When the customer reschedule button is SHOWN at all (confirmed + future). */
export function isCustomerRescheduleWindow(b: BookingMoveFields, now: Date = new Date()): boolean {
  return b.status === "confirmed" && new Date(b.start_time) > now;
}

/**
 * Whether a customer may reschedule: in the window AND NOT MATCHi-mirrored/pushed.
 * Mirrored/pushed rows → admin-only (see file header). In the window but blocked → show the button
 * DISABLED with an explanation (don't silently hide).
 */
export function canCustomerReschedule(b: BookingMoveFields, now: Date = new Date()): boolean {
  return (
    isCustomerRescheduleWindow(b, now) &&
    !b.matchi_slot_id &&
    !b.pushed_to_matchi_at
  );
}
